// src/services/screeningAPI.js
import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_BACKEND_URL;

const screeningAPI = {
  getCandidateProfile: (applicationId, token) =>
    axios.get(`${BASE_URL}/screening/candidate/${applicationId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),

  exportProfilePdf: (applicationId, token) =>
    axios.get(
      `${BASE_URL}/screening/candidate/${applicationId}/export`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }
    ),

  takeAction: (applicationId, actionData, token) =>
    axios.post(
      `${BASE_URL}/screening/candidate/${applicationId}/action`,
      actionData,
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  scheduleInterview: (applicationId, interviewData, token) =>
    axios.post(
      `${BASE_URL}/screening/candidate/${applicationId}/schedule-interview`,
      interviewData,
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  getUpcomingInterviews: (token) =>
    axios.get(`${BASE_URL}/screening/interviews/upcoming`, {
      headers: { Authorization: `Bearer ${token}` },
    }),

  recordFinalOutcome: (applicationId, outcomeData, token) =>
    axios.post(
      `${BASE_URL}/screening/candidate/${applicationId}/final-outcome`,
      outcomeData,
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  getAnalytics: (token) =>
    axios.get(`${BASE_URL}/screening/analytics`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
};

export { screeningAPI };
export default screeningAPI;
